import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../components/BodyCopy";
import { GradientText, Layout } from "lola-framework-ui-test";
import { AuraLayout } from "../components/AuraLayout";
import { useStore } from "../store/globalState";
import { useSessionStore } from "../store/useSessionStore";
import { getEvents, safeCapture } from "../analytics";

/**
 * Landing screen reached after the magic link is claimed and the partner theme
 * is applied. It is intentionally minimal: it confirms the session loaded and
 * renders with partner theming. The cash-deposit flow screens will be built on
 * top of this base.
 */
export const LandingPage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const { session } = useSessionStore();

  const colorConfig = theme.whiteView;
  const { title, bodyCopy } = colorConfig;

  const partnerName = session.data?.partner?.name ?? "";

  useEffect(() => {
    safeCapture(getEvents().LANDING_VIEW);
  }, []);

  return (
    <AuraLayout colorConfig={colorConfig}>
      <Layout.Content className="landing-section content-center">
        <section className="landing-container">
          <GradientText as="h1" textColor={title}>
            {t("landing.greeting")}
          </GradientText>
          {partnerName && (
            <BodyCopy textColor={bodyCopy}>{partnerName}</BodyCopy>
          )}
        </section>
      </Layout.Content>
    </AuraLayout>
  );
});
